import * as React from "react";

function IconInfo(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
      <path
        d="M8 14.667A6.666 6.666 0 108 1.335a6.666 6.666 0 000 13.332zm0-10A.667.667 0 118 6a.667.667 0 010-1.333zm-.667 2.666a.667.667 0 111.333 0v3.334a.667.667 0 11-1.333 0V7.333z"
        fill="#0071E9"
      />
    </svg>
  );
}

const MemoIconInfo = React.memo(IconInfo);
export default MemoIconInfo;
